import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n';
import utils from './utils';
import $ from 'jquery';
import getUserLocale from 'get-user-locale';
import './registerServiceWorker';
import axios from 'axios'
import 'bootstrap/dist/js/bootstrap.min'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueSkeletonLoading from 'vue-skeleton-loading';
import form from './components/form'
import filter from './components/filter'
import moment from 'vue-moment';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import {bus} from './bus';
import VueClipboard from 'vue-clipboard2';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import 'vue2-animate/dist/vue2-animate.min.css';
import GAuth from 'vue-google-oauth2';
import VueNativeNotification from 'vue-native-notification';
import ScrollLoader from 'vue-scroll-loader';

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

if (process.env.NODE_ENV !== 'production') {
    localStorage.debug = null;
}

Vue.component('v-select', vSelect);

Vue.use(GAuth, {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    scope: 'profile email https://mail.google.com/ https://www.googleapis.com/auth/gmail.readonly',
    prompt: 'consent',
    fetch_basic_profile: true
});


Sentry.init({
    Vue,
    dsn: "https://ef516df766874f9a81e8c665885961fc@o954932.ingest.sentry.io/5904176",
    integrations: [
        new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["localhost", "ttdh.callio.vn", /^\//],
        }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

Vue.use(BootstrapVue);
Vue.use(VueSkeletonLoading);
Vue.use(form);
Vue.use(filter);
Vue.use(moment);
Vue.use(VueSweetalert2);
Vue.use(VueClipboard);
Vue.use(ScrollLoader);
Vue.use(VueNativeNotification, {
    requestOnNotify: true
});
Vue.filter('numFormat', numFormat(numeral));

const serviceUrl = process.env.VUE_APP_SERVICE_URL;

const service = axios.create({
    baseURL: serviceUrl,
    timeout: 30000,
});

service.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (!error.response) {
        Vue.swal({
            text: 'Cannot connect to Phonenet server!',
            icon: 'error'
        });
    } else if (error.response.status === 401) {
        service.defaults.headers.common['token'] = null;
        bgService.defaults.headers.common['token'] = null;
        localStorage.removeItem('token');
        location.reload();
    } else if (error.response.status === 403) {
        if (error.response.data.message) {
            Vue.swal({
                text: error.response.data.message,
                icon: 'error'
            });
        } else {
            Vue.swal({
                text: 'Bạn không có quyền truy cập trang này',
                icon: 'error'
            }).then(function () {
                window.location = "#/";
            });
        }
    } else if (error.response.status === 406) {
        Vue.swal({
            text: 'Tài khoản của bạn đã hết hạn.',
            icon: 'error',
            confirmButtonText: 'Gia hạn',
        }).then(function () {
            window.location = "#/billing";
        });
    } else if (error.response.status === 500 || error.response.status === 404) {
        if (error.response.data.message) {
            Vue.swal({
                text: error.response.data.message,
                icon: 'error'
            });
        } else {
            Vue.swal({
                text: error.message,
                icon: 'error'
            });
        }
    }
    return Promise.reject(error);
});

const bgService = axios.create({
    baseURL: serviceUrl,
    timeout: 30000,
});

bgService.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

let locale = localStorage.getItem('locale');
if (!locale) {
    locale = getUserLocale().split('-')[0];
}
i18n.locale = locale;
service.defaults.headers.common['Accept-Language'] = i18n.locale;
bgService.defaults.headers.common['Accept-Language'] = i18n.locale;

Vue.prototype.$service = service;
Vue.prototype.$bgService = bgService;
Vue.prototype.$bus = bus;
Vue.prototype.$socket = null;
Vue.prototype.$utils = utils;

Vue.config.productionTip = false;

let token = localStorage.getItem('token');
router.beforeEach(function (to, from, next) {
    const publicPages = ['/login', '/register', '/forgot', '/reset', '/use'];
    let authRequired = true;
    publicPages.forEach(function (val) {
        if (to.path.startsWith(val)) {
            authRequired = false;
            return;
        }
    });
    if (authRequired) {
        if (!token && !store.state.user) {
            return next({
                path: '/login',
                query: {redirect: to.fullPath}
            });
        }
    }
    next();
});

const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
});

const mount = function () {
    $('#loading').remove();
    app.$mount('#app');
};

if (token) {
    store.commit('token', token);
    service.get('/profile').then(response => {
        store.dispatch('login', {
            token: token,
            user: response.data
        }).finally(() => {
            mount();
        });
    });
} else {
    mount();
}
